/* eslint-disable */
import { LoadingOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Button, Card, Col, DatePicker, Form, Input, Row, Spin, Table, Tabs, Tag, Tooltip, message } from 'antd';
import type { ColumnsType, SorterResult } from 'antd/es/table/interface';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import InstitutionUserService from '../../services/InstitutionUserService';
import { parseMoneyAmount } from '../../utils/parseMoneyAmount';
import { RefundStatsRangeAlert } from '../refund/RefundStatsRangeAlert';
import styles from '../../asserts/css/BiddersRefundRequest.module.css';


const antIcon = <LoadingOutlined style={{ fontSize: 'var(--base-font-size)', color: '#37762F' }} spin />
const { RangePicker } = DatePicker
interface DataType {
  index: any;
  key: React.Key
  bank_code: string
  transaction_reference: string
  debit_account_number: string
  debit_account_name: string
  beneficiary_account_name: string
  beneficiary_bank_name: string
  beneficiary_account_number: string
  transaction_currency: string
  amount: number
  reason: string
  status: string
  created_at: string;
  updated_at: string;
  column: string;
  totalPayments: string;
  amountRequestedToBeRefund: string;
  amountRequestedToBeRefundedInProgressStatus: string;
  TotalNumberOfApplicantRequestedRefund: string;
  notRequestedBidders: string;
  total: number;
  [key: string]: any;
}
const BidderNotRequestingBidSecurity: React.FC = () => {
  const [form] = Form.useForm()
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const navigate = useNavigate()
  const [filterStatus, setfilterStatus] = useState('')
  const [clear, setClear] = useState(false)
  const [refundRequestList, setRefundRequestList] = useState<DataType[]>([]);
  const [totalBidders, setTotalBidders] = useState<DataType | null>(null);
  const [loading, setLoading] = useState(false);
  /** Table fetch only — avoids fetchRefundStats clearing spin before bidder rows load */
  const [tableLoading, setTableLoading] = useState(false);
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({})
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [bailiffRefundRequestList, setBailiffRefundRequestList] = useState<DataType[]>([]);
  const [stats, setStats] = React.useState<DataType | null>(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [activeTab, setActiveTab] = useState('bidders'); // Default tab
  const [appliedFilters, setAppliedFilters] = useState<string[]>([]);
  const [token, setToken] = useState(() => {
    try {
      const u = JSON.parse(localStorage.getItem('userInfo') ?? '{}') as { token?: string }
      return typeof u?.token === 'string' ? u.token : ''
    } catch {
      return ''
    }
  })
  const [BiddersAmountRequestedToBeRefund, setBiddersAmountRequestedToBeRefund] = useState('')
  const [BailiffAmountRequestedToBeRefunded, setBailiffAmountRequestedToBeRefunded] = useState('')
  const [NewBiddersAmountRequestedToBeRefunded, setNewBiddersAmountRequestedToBeRefunded] = useState('')
  const [NewBailiffAmountRequestedToBeRefunded, setNewBailiffAmountRequestedToBeRefunded] = useState('')
  const [totalPaidForRange, setTotalPaidForRange] = useState('')

  useEffect(() => {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      async function fetchRefundStats () {
        setLoading(true)
        try {
          const response = await InstitutionUserService.viewRefundStatsByRefundStartDate(fromDate, toDate, token)
          const biddersAmountRequestedToBeRefund = response.data?.biddersAmountRequestedToBeRefund
          setBiddersAmountRequestedToBeRefund(response.data?.biddersAmountRequestedToBeRefund)
          const bailiffAmountRequestedToBeRefunded = response.data?.bailiffAmountRequestedToBeRefunded
          setBailiffAmountRequestedToBeRefunded(response.data?.bailiffAmountRequestedToBeRefunded)
          const newBiddersAmountRequestedToBeRefunded = response.data?.newBiddersAmountRequestedToBeRefunded
          setNewBiddersAmountRequestedToBeRefunded(response.data?.newBiddersAmountRequestedToBeRefunded)
          const newBailiffAmountRequestedToBeRefunded = response.data?.newBailiffAmountRequestedToBeRefunded
        setNewBailiffAmountRequestedToBeRefunded(response.data?.newBailiffAmountRequestedToBeRefunded)
        const tp = response.data?.totalPayments
        setTotalPaidForRange(tp != null && tp !== '' ? String(tp) : '')
      } catch (err) {
          void message.error('Failed to fetch refund stats')
          // eslint-disable-next-line no-console
          console.error(err)
        } finally {
          setLoading(false)
        }
      }

      void fetchRefundStats()
    },
    [fromDate, toDate, token])

  useEffect(() => {
    if (activeTab === 'bidders') {
      const total = refundRequestList.reduce((acc, curr) => acc + curr.amount, 0);
      setTotalAmount(total);
    }
  }, [refundRequestList, activeTab]);

  React.useEffect(() => {
    InstitutionUserService.RefundRequestStats()
      .then((res: any) => {
        setStats(res.data);
      })
      .catch((err) => {
        message.error(err?.message);
      });
  }, []);

  const handleTableChange = (pagination: any) => {
    setPagination(pagination) // Update pagination state on page change
  }
  let filter = ''
  if (filterStatus) {
    filter = filter + 'Type'
  }
  if (fromDate) {
    filter = filter === '' ? filter + 'From Date' : filter + ', From Date'
  }
  if (toDate) {
    filter = filter === '' ? filter + 'To Date' : filter + ', To Date'
  }

  const columnsToDownload = [
    'bank_code',
    'transaction_reference',
    'debit_account_number',
    'debit_account_name',
    'beneficiary_bank_name',
    'beneficiary_account_name',
    'beneficiary_account_number',
    'amount',
    'transaction_currency',
    'reason'
  ];
  // Convert column names to uppercase and remove underscores
  const formattedColumns = columnsToDownload.map(column =>
    column.toUpperCase().replace(/_/g, ' ')
  );

  const convertToCSV = (data: { [x: string]: any; }[], maxColumns: number = 10) => {
    const columnsToSkip = ['refund_request_id'];
    const originalColumns = Object.keys(data[0])
      .filter(col => !columnsToSkip.includes(col))
      .slice(0, maxColumns);

    // Remove underscores and convert to uppercase for display
    const formattedColumns = originalColumns.map(column =>
      column.toUpperCase().replace(/_/g, ' ')
    );

    // Create CSV header
    const header = formattedColumns.join(',') + '\n';

    // Create CSV rows
    const rows = data.map((row: { [x: string]: any; }) => {
      const rowData = formattedColumns.map((col) => {
        // Convert header back to original format to match data keys
        const column = col.toLowerCase().replace(/_/g, '_');
        let value = row[column];
        if (value === undefined || value === null) return '';
        value = value.toString().replace(/"/g, '""'); // Escape quotes
        return `"${value}"`; // Enclose in quotes
      }).join(',');

      return rowData;
    }).join('\n');

    return header + rows;
  };

  const downloadCSV = (csvContent: string, fileName: string, maxColumns: number = 10) => {
    const lines = csvContent.split('\n');
    const headerLine = lines[0].split(',');
    const transactionReferenceIndex = headerLine.indexOf('TRANSACTION REFERENCE');
    const debitAccountNumberIndex = headerLine.indexOf('DEBIT ACCOUNT NUMBER');
    const beneficiaryAccountNumberIndex = headerLine.indexOf('BENEFICIARY ACCOUNT NUMBER');
    const formattedLines = lines.map((line, lineIndex) => {
      const columns = line.split(',').slice(0, maxColumns);

      if (lineIndex > 0 && transactionReferenceIndex !== -1) {
        columns[transactionReferenceIndex] = '';
      }

      if (debitAccountNumberIndex !== -1) {
        // Remove any single quotes and ensure proper CSV formatting
        columns[debitAccountNumberIndex] = `"${columns[debitAccountNumberIndex].replace(/'/g, "''").replace(/"/g, '""')}"`;
      }

      if (beneficiaryAccountNumberIndex !== -1) {
        // Remove any single quotes and ensure proper CSV formatting
        columns[beneficiaryAccountNumberIndex] = `"${columns[beneficiaryAccountNumberIndex].replace(/'/g, "''").replace(/"/g, '""')}"`;
      }

      const formattedColumns = columns.map(column => {
        return column.replace(/"/g, ''); // Remove quotes
      }).join(',');

      return formattedColumns;
    });
    // Join all formatted lines into the final CSV content
    const formattedCSV = formattedLines.join('\n');
    const blob = new Blob([formattedCSV], { type: 'text/csv;charset=utf-8;' });

    if ((navigator as any).msSaveBlob) { // For IE 10+
      (navigator as any).msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('File download not supported on this browser.');
      }
    }
  };

  const handleDownloadExcel = async (): Promise<void> => {
    try {
      let dataToDownload: DataType[] = [];
      if (activeTab === 'bidders') {
        dataToDownload = refundRequestList;
      }

      const csvContent = convertToCSV(dataToDownload, 10);
      downloadCSV(csvContent, 'BankTransfersTemplate.csv');
    } catch (error) {
      console.error('Error occurred while downloading CSV:', error);
      message.warning("Error occurred while downloading CSV and updating refund request status.");
    }
  };
  // Converts data to sheet format and then to an Excel file
  const convertToExcel = (data: { [x: string]: any }[], maxColumns: number = 10): XLSX.WorkBook => {
    console.log('Converting data to Excel format...');

    // Define columns to be skipped
    const columnsToSkip = ['refund_request_id'];

    // Extract headers while excluding columns to be skipped
    const originalColumns = Object.keys(data[0])
      .filter(col => !columnsToSkip.includes(col))
      .slice(0, maxColumns);

    console.log('Original Columns:', originalColumns);

    // Prepare data for the worksheet
    const sheetData = data.map(row => {
      const rowData: { [key: string]: any } = {};
      originalColumns.forEach(column => {
        // Convert header back to original format to match data keys
        const columnKey = column.toLowerCase().replace(/ /g, '_');
        rowData[column] = row[columnKey] || '';
      });
      return rowData;
    });

    console.log('Sheet Data:', sheetData);
    // Create a worksheet from the data
    const ws = XLSX.utils.json_to_sheet(sheetData, { header: originalColumns });
    // Create a workbook and add the worksheet to it
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    console.log('Excel workbook created.');

    return wb;
  };

  // Downloads the Excel file
  const downloadExcel = (wb: XLSX.WorkBook, fileName: string) => {
    console.log('Preparing to download Excel file...');

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    if ((navigator as any).msSaveBlob) { // For IE 10+
      (navigator as any).msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('File download not supported on this browser.');
      }
    }

    console.log('Excel file downloaded.');
  };

  // Handle the process of downloading the Excel file
  const handleDownloadExcelFile = async (): Promise<void> => {
    try {
      console.log('Handling download of Excel file...');

      let dataToDownload: { [x: string]: any }[] = [];
      if (activeTab === 'bidders') {
        dataToDownload = refundRequestList;
      }

      console.log('Data to download:', dataToDownload);

      const wb = convertToExcel(dataToDownload, 10);
      downloadExcel(wb, 'New Refund Request Report.xlsx');
    } catch (error) {
      console.error('Error occurred while downloading Excel:', error);
      message.warning("Error occurred while downloading Excel and updating refund request status.");
    }
  };

  const clearFilter = (): void => {
    setfilterStatus('')
    form.setFieldValue('filterStatus', '')
    form.setFieldValue('range_picker', ['', ''])
    setFromDate('')
    setToDate('')
    setClear((prev) => !prev)
  }

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const onRefundRequestSearch = (event?: any): void => {
    setTableLoading(true);

    if (activeTab !== 'bidders') {
      setTableLoading(false);
      message.error('Invalid tab selected.');
      return;
    }

    const search =
      event?.target?.value != null && String(event.target.value).trim() !== ''
        ? String(event.target.value).trim()
        : undefined

    void InstitutionUserService.GetBiddersNotRequestedBidSecurityReport({
      limit: pagination.pageSize as number,
      page: pagination.current as number,
      search,
      from: fromDate !== '' ? fromDate : undefined,
      to: toDate !== '' ? toDate : undefined
    })
      .then((res: any) => {
        const raw: any[] = Array.isArray(res?.data) ? res.data : []
        if (res?.status != null && res.status !== 200 && res.status !== '200' && raw.length === 0) {
          message.error('Unexpected response status.');
          setRefundRequestList([])
          return
        }
        const mapped = raw.map((r: any, idx: number) => ({
          ...r,
          key: `${String(r.reference_number ?? r.transaction_reference ?? r.bid_security_ref_number ?? '')}-${idx}`,
          index: idx,
          full_name: r.bidder_full_name ?? r.full_name ?? '',
          nid: r.bidder_nid ?? r.nid ?? '',
          phone_number: r.bidder_phone_number ?? r.phone_number ?? '',
          email: r.bidder_email ?? r.email ?? '',
          reference_number: r.reference_number ?? r.transaction_reference ?? r.bid_security_ref_number ?? '',
          ref_number: r.reference_number ?? r.transaction_reference ?? r.bid_security_ref_number ?? r.ref_number ?? '',
          transaction_reference: r.transaction_reference ?? r.reference_number ?? r.bid_security_ref_number ?? '',
          amount: r.payment_amount ?? r.amount
        }))
        setRefundRequestList(mapped)
        setTotalBidders(res?.meta ?? null)
        setPagination((prev) => ({
          ...prev,
          total: res?.meta?.total ?? mapped.length
        }))
      })
      .catch((err: any) => {
        // Handle errors except for canceled operations
        if (err?.message !== 'Operation canceled due to new request.') {
          message.error(err?.message || 'An error occurred.');
        }
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  useEffect(() => {
    onRefundRequestSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refresh when filters/pagination/tab change
  }, [activeTab, pagination.pageSize, pagination.current, filterStatus, fromDate, toDate, clear]);

  const biddersColumns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      width: 90,
      render: (text, record, index) => {
        const pageNumber = pagination.current || 1
        const pageSize = pagination.pageSize || 10
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>;
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false,
    },
    {
      title: 'Bidder',
      dataIndex: 'full_name',
      key: 'full_name',
      width: 250,
      sorter: (a: any, b: any) => a?.full_name.localeCompare(b?.full_name),
      sortOrder: sortedInfo?.columnKey === 'full_name' ? sortedInfo?.order : null,
      ellipsis: true,
      render: (text: string) => (
          <span>{text != null && text !== '' ? String(text).toUpperCase() : ''}</span>
      ),
    },
    {
      title: 'National ID',
      dataIndex: 'nid',
      key: 'nid',
      width: 170,
      sorter: (a: any, b: any) =>
        a?.nid.localeCompare(b?.nid),
      sortOrder: sortedInfo?.columnKey === 'nid' ? sortedInfo?.order : null,
      ellipsis: true,
      render: (text: string, record: any) => (
          <span>{text}</span>
      ),
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 120,
      sorter: (a: any, b: any) =>
        a?.phone_number.localeCompare(b?.phone_number),
      sortOrder: sortedInfo?.columnKey === 'phone_number' ? sortedInfo?.order : null,
      ellipsis: true,
      render: (text: string, record: any) => (
          <span>{text}</span>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 230,
      sorter: (a: any, b: any) =>
        a?.email.localeCompare(b?.email),
      sortOrder: sortedInfo?.columnKey === 'email' ? sortedInfo?.order : null,
      ellipsis: true,
      render: (text: string, record: any) => (
          <span>{text}</span>
      ),
    },
    {
      title: 'Reference number',
      dataIndex: 'reference_number',
      key: 'reference_number',
      width: 160,
      sorter: (a: any, b: any) =>
        String(a?.reference_number ?? a?.transaction_reference ?? a?.ref_number ?? '').localeCompare(String(b?.reference_number ?? b?.transaction_reference ?? b?.ref_number ?? '')),
      sortOrder: sortedInfo?.columnKey === 'reference_number' ? sortedInfo?.order : null,
      ellipsis: true,
      render: (_text: string, record: any) => (
        <span>{record.reference_number ?? record.transaction_reference ?? record.ref_number ?? ''}</span>
      ),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      width: 130,
      render: (_text: any, record: any) => {
        // Safely access nested values using optional chaining
        const amount = parseInt(String(record?.amount ?? record?.payment_amount ?? '0'), 10);

        // Format amount and handle missing/undefined amounts
        return amount > 0 ? `${amount.toLocaleString()} Rwf` : 'N/A';
      },
      sorter: (a: any, b: any) => {
        // Safely parse and compare amounts for sorting
        const amountA = parseInt(String(a?.amount ?? a?.payment_amount ?? '0'), 10);
        const amountB = parseInt(String(b?.amount ?? b?.payment_amount ?? '0'), 10);
        return amountA - amountB;
      },
      sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
      ellipsis: true
    }
  ]
  // Function to calculate total amount
  return (
    <div style={{ width: '100%' }}>
      {/* Add custom styles for table rows */}
      <style>{`
        .table-row-light {
          background-color: #ffffff;
        }
        .table-row-dark {
          background-color: #ffffff;
        }
        .table-row-light:hover,
        .table-row-dark:hover {
          background-color: #f9fafb !important;
        }
        .ant-table-thead > tr > th {
          background-color: #f8f8f8 !important;
          border-bottom: 1px solid #e5e7eb !important;
          border-right: 1px solid #e5e7eb !important;
          font-weight: 600 !important;
          color: #374151 !important;
          font-size: 14px !important;
          text-align: left !important;
          padding: 12px 16px !important;
          font-family: 'Avenir', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
        }
        .ant-table-thead > tr > th:last-child {
          border-right: none !important;
        }
        .ant-table-tbody > tr > td {
          border-bottom: 1px solid #e5e7eb !important;
          border-right: 1px solid #e5e7eb !important;
          padding: 12px 16px !important;
          text-align: left !important;
          font-size: 14px !important;
          color: #1f2937 !important;
        }
        .ant-table-tbody > tr > td:last-child {
          border-right: none !important;
        }
        .ant-table-column-sorter {
          color: #9ca3af !important;
          margin-left: 4px !important;
        }
        .ant-table-column-sorter-up,
        .ant-table-column-sorter-down {
          color: #9ca3af !important;
          font-size: 12px !important;
        }
        .ant-table-column-sorter-up.active,
        .ant-table-column-sorter-down.active {
          color: #374151 !important;
        }
        /* Responsive table adjustments */
        .ant-table-wrapper {
          overflow-x: auto;
        }
        @media (max-width: 768px) {
          .ant-table-thead > tr > th {
            font-size: 12px !important;
            padding: 8px 10px !important;
          }
          .ant-table-tbody > tr > td {
            font-size: 12px !important;
            padding: 8px 10px !important;
          }
          .ant-pagination {
            font-size: 12px !important;
          }
        }
        @media (max-width: 480px) {
          .ant-table-thead > tr > th {
            font-size: 11px !important;
            padding: 6px 8px !important;
          }
          .ant-table-tbody > tr > td {
            font-size: 11px !important;
            padding: 6px 8px !important;
          }
        }
      `}</style>

      <div className="px-5 py-4 border-b-slate-200 border border-solid" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px',
      }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }}>
            <div className="text-title font-bold flex items-center" style={{ minWidth: 0 }}>
              <div style={{
                background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                borderRadius: '50%',
                width: 'clamp(36px, 6vw, 48px)',
                height: 'clamp(36px, 6vw, 48px)',
                minWidth: 'clamp(36px, 6vw, 48px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)',
                flexShrink: 0,
              }}>
              <span style={{ fontSize: 'clamp(18px, 3vw, 24px)' }}>👥</span>
              </div>
            <div style={{ minWidth: 0 }}>
                <h2 className="text-title font-bold" style={{
                  margin: 0,
                  background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                }}>
                  Not Requesting Bid Security
                </h2>
                <p style={{
                  margin: '4px 0 0 0',
                  fontSize: 'clamp(11px, 1.5vw, 14px)',
                  color: '#6b7280',
                  fontWeight: '500',
                  whiteSpace: 'normal',
                }}>
                📅 Bidders Not Requesting Bid Security • Financial Overview Dashboard
                </p>
              </div>
            </div>
          </div>
        </div>
      <div className={styles['header-stat']}>
        <RefundStatsRangeAlert fromDate={fromDate} toDate={toDate} />
        {/* Enhanced stats section with hover effects - Responsive */}
        <div style={{
          padding: 'clamp(12px, 2vw, 20px)',
          backgroundColor: '#fafafa',
          borderRadius: '8px',
          margin: '0 clamp(8px, 2vw, 20px)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
        className={styles['stats-container']}
        >
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
              <div
                className="stat-card"
                style={{
                  width: '100%',
                  background: '#f8fafc',
          padding: '20px',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          textAlign: 'center',
                  color: '#111827',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'default',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                }}
              >
                <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
            Total Amount Requested
          </div>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {((parseMoneyAmount(BailiffAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(BiddersAmountRequestedToBeRefund) ?? 0)).toLocaleString()} Rwf
          </div>
        </div>
            </Col>

            <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
              <div
                className="stat-card"
                style={{
                  width: '100%',
                  background: '#f8fafc',
          padding: '20px',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          textAlign: 'center',
                  color: '#111827',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'default',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                }}
              >
                <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
            New Amount Requested
          </div>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded) ?? 0)).toLocaleString()} Rwf
          </div>
        </div>
            </Col>

            <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
              <div
                className="stat-card"
                style={{
                  width: '100%',
                  background: '#f8fafc',
          padding: '20px',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          textAlign: 'center',
                  color: '#111827',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'default',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                }}
              >
                <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
            Remaining to Request
          </div>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {Math.max(
              0,
              parseMoneyAmount(totalPaidForRange) - (parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))
            ).toLocaleString()} Rwf
          </div>
        </div>
            </Col>

            <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
              <div
                className="stat-card"
                style={{
                  width: '100%',
                  background: '#f8fafc',
          padding: '20px',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          textAlign: 'center',
                  color: '#111827',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'default',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                }}
              >
                <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
            Total Paid Amount
          </div>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {(parseMoneyAmount(totalPaidForRange)).toLocaleString()} Rwf
          </div>
        </div>
            </Col>

            <Col xs={24} sm={12} md={8} lg={4} xl={4} xxl={4}>
              <div
                className="stat-card"
                style={{
                  width: '100%',
                  background: '#f8fafc',
          padding: '20px',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          textAlign: 'center',
                  color: '#111827',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          cursor: 'default',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                }}
              >
                <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
            Total Refunded Amount
          </div>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
            {(((parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))) - ((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded)) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded)))).toLocaleString()} Rwf
          </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div style={{ padding: '0 clamp(8px, 3vw, 28px)' }}>
        <div className="py-1">
          <Form
            name="normal_login"
            layout="vertical"
            className="login-form p-2"
            initialValues={{ remember: true }}
            form={form}
          >
            <Card
              className="bg-gradient-to-r from-blue-50 to-indigo-50"
              style={{
                borderRadius: '12px',
                border: '1px solid #e0e7ff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
              }}
            >
              <Row gutter={16}>
                <Col xs={24} xl={18}>
                  <Form.Item
                    name="range_picker"
                    label={<span style={{ fontWeight: '600', color: '#374151' }}>Select Date Range</span>}
                  >
                    <RangePicker
                      size="large"
                      className="w-full"
                      allowClear
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e5e7eb',
                        transition: 'border-color 0.2s ease',
                      }}
                      onChange={(value, valueString) => {
                        setFromDate(valueString[0])
                        setToDate(valueString[1])
                      }}
                    />
                  </Form.Item>
                  {filter !== ''
                    ? (
                      <div className="flex justify-between pb-2.5 md:pb-0">
                        <div>
                          Applied filters: <span className="font-medium">{filter}</span>
                        </div>
                        <div
                          className="bg-black text-center py-0.5 px-2.5 text-white rounded-sm font-medium cursor-pointer"
                          onClick={clearFilter}
                        >
                          Clear X
                        </div>
                      </div>
                    )
                    : (
                      ''
                    )}
                </Col>
                <Col xs={24} xl={6}>
                  <Form.Item label={<span style={{ color: 'transparent' }}>Action</span>}>
                    <Button
                      type="primary"
                      size="large"
                      className="w-full font-bold"
                      onClick={handleDownloadExcel}
                      disabled={fromDate.length === 0 || toDate.length === 0}
                      style={{
                        background: fromDate.length === 0 || toDate.length === 0
                          ? '#d1d5db'
                          : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: '600',
                        boxShadow: fromDate.length === 0 || toDate.length === 0
                          ? 'none'
                          : '0 4px 12px rgba(16, 185, 129, 0.3)',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        if (fromDate.length > 0 && toDate.length > 0) {
                          e.currentTarget.style.transform = 'translateY(-1px)';
                          e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (fromDate.length > 0 && toDate.length > 0) {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
                        }
                      }}
                    >
                      📥 DOWNLOAD REPORT
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Form>
        </div>
        <Card
          title={
            <div style={{
              background: 'var(--refund-theme-primary-soft)',
              color: '#111827',
              padding: '12px 20px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}>
              <span>👥</span>
              Bidders Not Requesting Bid Security
            </div>
          }
          style={{
            marginTop: '20px',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
          }}
          headStyle={{
            background: 'transparent',
            borderBottom: '1px solid #e5e7eb',
            padding: '0',
          }}
        >
          {/* Enhanced search bar */}
          <div className="search-container" style={{
            width: '100%',
            marginBottom: 16,
            display: 'block',
              }}>
                <Input
                  size="large"
                  placeholder="🔍 Quick search in the tables"
                  prefix={<ZoomOutOutlined style={{ color: '#6b7280' }}/>}
                  onChange={onRefundRequestSearch}
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                    border: '2px solid #e5e7eb',
                    transition: 'border-color 0.2s ease',
                  }}
                />
              </div>
          <Tabs
            onChange={(key) => handleTabChange(key)}
            type="card"
            size="large"
            defaultActiveKey="bidders"
          >
            <Tabs.TabPane
              tab={
                <span style={{
                  fontWeight: '600',
                  color: '#374151',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}>
                  👥 Bidders
                </span>
              }
              key="bidders"
            >
              {/* Responsive scroll for table on small devices */}
              <div className="overflow-x-auto md:overflow-x-visible">
              <Spin
                spinning={tableLoading}
                indicator={antIcon}
                tip={
                  <span style={{
                    color: '#37762f',
                    fontWeight: '500',
                  }}>
                    🔄 Loading bidders data...
                  </span>
                }
              >
                  <div style={{ width: '100%', overflowX: 'auto' }}>
                <Table
                  columns={biddersColumns}
                  dataSource={refundRequestList}
                  onChange={handleTableChange}
                  pagination={{
                    ...pagination,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                        hideOnSinglePage: false,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        showLessItems: true,
                    style: {
                          background: '#F5F5F5',
                          borderRadius: '8px',
                          padding: '12px',
                          border: '1px solid #e5e7eb',
                          marginTop: '16px'
                        }
                  }}
                  loading={tableLoading}
                      scroll={{ x: 900 }}
                  style={{
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }}
                  rowClassName={(record, index) =>
                    index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                  }
                />
                  </div>
              </Spin>
              </div>
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </div>
    </div>
  );
};

export default BidderNotRequestingBidSecurity;
